
    import {
        defineComponent, PropType,
    } from 'vue';
    import ButtonDesktop from '@ve/components/button/desktop/Button.vue';
    import { formatNumber, wordEnding } from '@ve/services/textModifiers';

    import { IRailwayToursListItem } from '../common/types';
    import useRailwayTourItem from '../common/useRailwayTourItem';

    export default defineComponent({
        name: 'railway-tour-item',
        components: {
            ButtonDesktop,
        },
        props: {
            railwayTourSelected: {
                type: Boolean,
                required: true,
            },
            railwayTourItem: {
                type: Object as PropType<IRailwayToursListItem>,
                required: true,
            },
        },
        setup(props) {
            const {
                thereDateCommon,
                departureDateThereText,
                arrivalDateThereText,
                backDateCommon,
                departureDateBackText,
                arrivalDateBackText,
                checkInOutDateCommon,
                checkInDate,
                checkOutDate,
            } = useRailwayTourItem(props);

            return {
                thereDateCommon,
                departureDateThereText,
                arrivalDateThereText,
                backDateCommon,
                departureDateBackText,
                arrivalDateBackText,
                checkInOutDateCommon,
                checkInDate,
                checkOutDate,
                formatNumber,
                wordEnding,
            };
        },
    });
